<template>
  <v-dialog
    persistent
    v-model="showDialog"
    max-width="700px"
  >
    <ApplicationMessage
      title="Meddela inblandade parter"
      :infoText="infoText"
      :defaultMessage="defaultMessage"
      @close="close"
      @send="send"
    />
  </v-dialog>
</template>

<script>
import ApplicationMessage from '@/components/application/ApplicationMessage'

// @group Application
// RefuseApplicationModal component
export default {
  name: 'RefuseApplicationModal',

  components: {
    ApplicationMessage
  },

  props: {
    // Should dialog be showed
    show: {
      // `true` / `false`
      type: Boolean,
      // The default value is: `false`
      default: false
    }
  },

  data: () => ({
    showDialog: false,
    defaultMessage: 'Hej. Er anmälan behöver kompletteras.',
    infoText: 'Vill du meddela inblandade parter om att anmälan behöver kompletteras?'
  }),

  watch: {
    show() {
      this.showDialog = this.show
    }
  },

  methods: {
    close() {
      // Fire close event
      // @arg called with no argument , close the modal
      this.$emit('close')
    },

    send(message) {
      // Fire send event , when form is submited
      // @arg The argument is a string representing the message
      this.$emit('send', message)
    }
  }
}
</script>

<style>
</style>